import validate from "/home/runner/work/ronaldo-web/ronaldo-web/node_modules/.pnpm/nuxt@3.15.4_@parcel+watcher@2.5.0_@types+node@22.10.5_db0@0.2.1_eslint@9.17.0_jiti@2.4._212e2606cca0637fdea856835b76a213/node_modules/nuxt/dist/pages/runtime/validate.js";
import setup_45global from "/home/runner/work/ronaldo-web/ronaldo-web/app/common/middleware/setup.global.ts";
export const globalMiddleware = [
  validate,
  setup_45global
]
export const namedMiddleware = {}